import React from "react";
import {
  Col,
  Row,
  message,
  Button,
  Space,
  Tooltip,
  Modal,
  Image,
  Drawer,
  Select,
  Form,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import VehicleDistanceStore from "../store/VehicleDistanceStore";
import withRouter from "../withRouter";
import CompanyStore from "../store/CompanyStore";
import StudentTripAdd from "./StudentTripAdd";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import StudentStore from "../store/StudentStore";
import StudentTripStore from "../store/StudentTripStore";
import deleteVehicleIcon from "../assets/images/NewDesign/delete-vehicle.svg";
import assignIcon from "../assets/images/NewDesign/assign.svg";
import FormItem from "antd/es/form/FormItem";
import VehicleWorkingHoursStore from "../store/VehicleWorkingHoursStore";

class StudentTripList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.companyStore = new CompanyStore(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.studentStore = new StudentStore(this);
    this.studentTripStore = new StudentTripStore(this);
    this.vehicleDistanceStore = new VehicleDistanceStore();
    this.workingHoursStore = new VehicleWorkingHoursStore();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      companyId: "",
      loadData: 0,
      openConfirm: false,
      confirmLoading: false,
      company_value_label: "",
      listUpdated: 0,
      stId: "",
      openStudentTripForm: false,
      listDataUpdate: false,
      openDeleteModal: false,
      deleteData: {},
      selectedTrips: [],
    };

    this.columns = [
      {
        title: context.translate("_TRIP_NAME_"),
        dataIndex: "tripName",
        width: 25,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  // this.props.canUpdate('vehicledistancelist') &&
                  this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        // title: " Vehicle No ",
        title: context.translate("_TRIP_TYPE_"),
        dataIndex: "TripType",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_NO_OF_STUDENTS_"),
        dataIndex: "AssignStudent",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        // fixed: 'right',
        width: 10,
        align: "center",
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          return (
            <>
              <Space>
                <Tooltip
                  title={this.context.translate(
                    "_FLEET_COMPANY_COMPANYLIST_EDIT_"
                  )}
                >
                  {/* {this.props.canUpdate('vehicledistancelist') &&  */}

                  <Image
                    style={{
                      height: "19px",
                      width: "15px",
                      borderRadius: "0px",
                      cursor: "pointer",
                    }}
                    src={editIcon}
                    onClick={async (e) => {
                      e.preventDefault();
                      await this.onEdit(record);
                    }}
                  ></Image>
                  {/* } */}
                </Tooltip>
                <Tooltip title={this.context.translate("_ASSIGN_")}>
                  {/* {this.props.canUpdate('vehicledistancelist') &&  */}

                  <Image
                    style={{
                      height: "20px",
                      width: "20px",
                      borderRadius: "0px",
                      cursor: "pointer",
                    }}
                    src={assignIcon}
                    onClick={async (e) => {
                      e.preventDefault();
                      this.setState({
                        openAssignForm: true,
                        assignData: record,
                      });
                      // await this.assignVehicle(record);
                    }}
                  ></Image>
                  {/* } */}
                </Tooltip>
              </Space>
            </>
          );
        },
      },
    ];
  }
  onEdit = async (record) => {
    console.log(record);
    await this.context.viewStateStore.setStudentTripDetails({
      companyId: record.companyId,
    });
    await this.setState({ stId: record.stId });
    await this.setState({ openStudentTripForm: true });
  };

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      console.log("didupdate", this.context.viewStateStore.studentTripDetailsObject.companyId)
      const beforeEditCompanyId =
        this.context.viewStateStore.studentTripDetailsObject.companyId;
      console.log("beforeEditCompanyId", beforeEditCompanyId)
      if (beforeEditCompanyId !== "") {
        await this.studentTripStore.loadTripData(
          beforeEditCompanyId,
          (this.state.currentPage - 1) * this.state.pageSize, //offset:
          this.state.pageSize //limit:
        );
        const singleData = await this.companyStore.getCompanyDataById(
          this.context.viewStateStore.studentTripDetailsObject.companyId
        );
        await this.setState({ company_value_label: singleData });
        this.setState({ listDataUpdate: false });
      }
    }
  }
  async componentDidMount() {
    if (Number(this.props.getUserData().isadmin) !== -1) {
      console.log(this.props.getUserData().userCompanyId);
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }
    // await this.vehicleDistanceStore.loadData({ offset: 0, limit: 50 });

    await this.setState({ listUpdated: 1 }); //need to reload data

    this.setState({ pageSize: 50 });
  }
  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ company_value_label: singleData });

    await this.handleSearch();
  }

  async handleSearch() {
    console.log("company ", this.state.companyId);
    this.setState({ loading: true });
    await this.studentTripStore.loadTripData(
      this.state.companyId,
      (this.state.currentPage - 1) * this.state.pageSize,
      this.state.pageSize,
      this.state.currentPage
    );
    await this.workingHoursStore.getAssignAsset({
      companyId: this.state.companyId,
    });

    // await this.studentRouteStore.loadData({
    //     offset: 0,
    //     limit: 50,
    //     companyId: this.state.companyId
    // });
    await this.setState({ loadData: 1 });
  }

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.studentTripStore.loadTripData(this.state.companyId, 0, 50);
    }
    this.setState({ loading: false, currentPage: 1 });
  };
  closeModal = () => {
    this.setState({
      openStudentTripForm: false,
      stId: "",
    });
  };

  deleteMultipleTrips = async () => {
    if (this.state.selectedTrips.length > 0) {
      const data = {
        tripId: this.state.selectedTrips,
      };
      const response = await this.studentTripStore.deleteMultipleTrips(data);
      console.log("object", response);
      if (response?.success === "S") {
        message.success(response?.message);
        this.handleSearch();
      }
    }
  };
  responseMsg = (resp) => {
    console.log("list********* ", resp.data);

    if (resp.success === "S") {
      this.setState(
        {
          listDataUpdate: true,
          openStudentTripForm: false,
        },
        () => {
          this.handleSearch(); // or fetchList() or reload API
        }
      );
    } else {
      message.error(resp.message);
    }
  };
  assignBus = async () => {
    const data = {
      vehicleId: this.state.vehicleId,
      tripId: this.state.assignData.stId,
    };
    console.log(data);
    const response = await this.studentTripStore.assignBus(data);
    console.log("object", response);
    if (response?.success === "S") {
      message.success(response?.message);
      this.handleSearch();
    } else {
      message.error(response?.message);
    }
    this.setState({ openAssignForm: false });
  };

  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  value={
                    this.state.company_value_label
                      ? this.state.company_value_label
                      : null
                  }
                  onChange={(value) => this.handleChange(value)}
                  style={{ width: 200 }}
                />
              </Space>
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    alignItems: "center",
                    cursor: "pointer",
                    marginInlineEnd: "20px",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>
              <Tooltip
                title={this.context.translate("_DELETE_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    alignItems: "center",
                    cursor: "pointer",
                    marginInlineEnd: "20px",
                  }}
                  src={deleteVehicleIcon}
                  onClick={() => this.setState({ openDeleteModal: true })}
                ></Image>
              </Tooltip>
              {/* {this.props.canCreate('vehicledistancelist') && */}
              <Button
                className="addButtonClass"
                onClick={() => {
                  this.setState({
                    openStudentTripForm: true,
                    stId: "",
                  });
                }}
              >
                <Image
                  style={{ marginInlineEnd: "5px", width: 13 }}
                  src={require("../assets/images/NewDesign/plus (Stroke).png")}
                ></Image>
                {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
              </Button>
              {/* } */}
            </Col>
          </Row>

          <ListTable
            rowSelection={{
              columnWidth: 10,
              preserveSelectedRowKeys: true,
              selectedRowKeys: Array.isArray(this.state.selectedTrips)
                ? this.state.selectedTrips
                : [],
              onChange: async (selectedRowKeys, selectedRows) => {
                await this.setState({ selectedTrips: selectedRowKeys });
              },
            }}
            rowKey="stId"
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.studentTripStore?.totalTripCount}
            columns={this.columns}
            dataSource={this.studentTripStore?.tripDetails}
            loading={this.studentTripStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openStudentTripForm && (
          <Drawer
            className="accountFormDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openStudentTripForm}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            maskClosable={false}
            onOk={() => this.setState({ openStudentTripForm: false })}
            onCancel={() =>
              this.setState({ openStudentTripForm: false, stId: "" })
            }
          >
            <div
              style={{
                height: "90%",
              }}
            >
              <StudentTripAdd
                stId={this.state.stId}
                responseMsg={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openAssignForm && (
          <Modal
            maskClosable={false}
            title={
              <div className="confirmStatusTitle">
                <span>{this.context.translate("_ASSIGN_BUS_")}</span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openAssignForm: false })}
                />
              </div>
            }
            className="update-statusModal"
            // title={this.context.translate("_ASSIGN_BUS_")}
            // description="Are you sure to change this status?"
            centered
            open={this.state.openAssignForm}
            //footer={null}
            onOk={this.assignBus}
            onCancel={() => {
              this.setState({ openAssignForm: false });
            }}
            width={400}
            footer={null}
          >
            <Select
              // placeholder="Select Asset"
              placeholder={this.context.translate(
                "_FLEET_GROUP_GROUPDETAIL_SELECTVEHICLE_"
              )}
              style={{ width: "100%" }}
              // mode="multiple"
              showSearch
              fieldNames={{ value: "vehicleId", label: "vehicleNo" }}
              optionFilterProp="children"
              options={this.workingHoursStore?.assignAssetList}
              onChange={async (val) => {
                this.setState({ vehicleId: val });
                // await this.getRouteDetails();
              }}
            />

            <div className="confirmStatusButtons" style={{ marginTop: "13px" }}>
              <Button
                onClick={() => this.setState({ openAssignForm: false })}
                className="confirmStatusCancelButton"
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="confirmStatusOkButton"
                onClick={() => this.assignBus()}
              >
                {this.context.translate(
                  "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_"
                )}
              </Button>
            </div>
          </Modal>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={
              this.state.selectedTrips.length !== 0 &&
              this.state.openDeleteModal
            }
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_SURE_TO_DELETE_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={(e) => {
                  this.deleteMultipleTrips();

                  this.setState({
                    openDeleteModal: false,
                    selectedTrips: [],
                  });
                }}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
StudentTripList.contextType = StoreContext;
export default observer(withRouter(StudentTripList));
